export const DEFAULT_RECIPE_PHOTO_FRAMING = Object.freeze({
  image_position_x: 0.5,
  image_position_y: 0.5,
  image_scale: 1,
});

const clamp = (value, min, max) => Math.min(max, Math.max(min, value));

export function normalizeRecipePhotoFraming(source = {}) {
  const x = Number(source?.image_position_x);
  const y = Number(source?.image_position_y);
  const scale = Number(source?.image_scale);
  return {
    image_position_x: Number.isFinite(x) ? clamp(x, 0, 1) : 0.5,
    image_position_y: Number.isFinite(y) ? clamp(y, 0, 1) : 0.5,
    image_scale: Number.isFinite(scale) ? clamp(scale, 1, 3) : 1,
  };
}

export function recipePhotoStyle(source) {
  const framing = normalizeRecipePhotoFraming(source);
  return {
    objectFit: "cover",
    objectPosition: `${framing.image_position_x * 100}% ${framing.image_position_y * 100}%`,
    transform: `scale(${framing.image_scale})`,
    // At scale=1 object-position pans the intrinsic cover overflow. At user
    // zoom > 1 the matching transform-origin makes the same metadata pan the
    // newly-created overflow as well, while the scaled image still covers the
    // whole frame at every clamped position.
    transformOrigin: `${framing.image_position_x * 100}% ${framing.image_position_y * 100}%`,
  };
}

export const CLEARED_RECIPE_PHOTO = Object.freeze({
  image_media_id: null,
  image_url: null,
  image_position_x: null,
  image_position_y: null,
  image_scale: null,
});
